export default function truncateString(str, length = 200, ending = '...') {
    if (str && str.length > length) {
      return str.substring(0, length - ending.length) + ending
    }
    return str
  }
  


// WEBPACK FOOTER //
// ./src/views/Components/truncateString.js